import api from '@edu-fe/api'

export default {
  name: 'today',
  namespaced: true,
  state: {
    courseList: [],
    status: 0, // 0: 未购课程 1: 已购
    popularCourses: [],
  },
  mutations: {
    setCourseList: (state, data) => (state.courseList = data),
    // setStatus: (state, data) => (state.status = data),
    setPopularCourses: (state, data) => (state.popularCourses = data),
    // setPrivilege: (state, data) => (state.isPrivilege = data),
  }
  ,
  actions: {
    async getCourseList ({ commit }) {
      try {
        const { data } = await api.mine.course()
        // console.log(data)
        commit('setCourseList', data || [])
      } catch (e) {
        console.log(e)
      }
    },
    async getPopularCourses ({ commit }) {
      const { data } = await api.privilege.getCourses()
      data.map((item) => {
        item.name = item.title
      })
      commit('setPopularCourses', data)
    },
    async deleteCourse ({ commit, state }, index) {
      const courseId = state.courseList[index].id
      const { data } = await api.mine.deleteCourse(courseId)()
      console.log(data)
      if (data === 'success') {
        state.courseList.splice(index, 1)
      }
    }
  }
}
